<soft-validation-message
  *ngFor="let validation of validation?.messages"
  [message]="validation"
></soft-validation-message>
